import { render, staticRenderFns } from "./ConsultarOrcamentos.vue?vue&type=template&id=0546ea73&"
import script from "./ConsultarOrcamentos.vue?vue&type=script&lang=js&"
export * from "./ConsultarOrcamentos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports